var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",staticClass:"questionnaire-element-wrapper",class:{
    halfWidth: _vm.isDateField,
    'margin-b-1': _vm.elementComponent === 'title-element'
  }},[(_vm.item !== null)?_c(_vm.elementComponent,{ref:"element",tag:"component",attrs:{"readOnly":_vm.readOnly,"printView":_vm.printView,"preview":_vm.preview,"transferredData":_vm.transferredData},on:{"errorOnSave":function($event){return _vm.$emit('errorOnSave')}},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }